// extracted by mini-css-extract-plugin
export default {"paragraph-node-container":"ParagraphNode_paragraph-node-container__9YfCK","content":"ParagraphNode_content__EjyJ1"};